import React from "react";

export default function HtmlContainer({ children = "" }) {
  return (
    <div className={`h-screen relative overflow-hidden bg-back`}>
      <div className="text-primary border-primary bg-primary"></div>
      <div className="text-secondary border-secondary bg-secondary"></div>
      <div className="text-dark-blue border-dark-blue bg-dark-blue"></div>
      <div className="text-success border-success bg-success"></div>
      <div className="text-warning border-warning bg-warning"></div>
      <div className="text-error border-error bg-error"></div>
      <div className="font-teko"></div>
      <div className="font-mont"></div>
      <div className="w-full h-screen overflow-x-hidden flex scroll-thumb">
        {children}
      </div>
    </div>
  );
}
